import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=9a6b511e&scoped=true&"
import script from "./FeedbackButton.vue?vue&type=script&lang=ts&"
export * from "./FeedbackButton.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackButton.vue?vue&type=style&index=0&id=9a6b511e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6b511e",
  null
  
)

export default component.exports